import { Feed } from './feed'

export default Feed
